import LogoSonabel from "../../assets/Logo-site-SONABEL-def.png";
const ConditionsDemande = ({message}) => (
  <div className="flex flex-col items-center">
    <div className="text-center items-center mt-4">
      <img src={LogoSonabel} alt="Logo Sonabel" width={200} />
    </div>
    <div className="text-justify m-8">
      <h2 className="mb-2 text-lg font-bold text-gray-900 dark:text-white">
        Conditions pour cette demande :
      </h2>
      <ol className="max-w-md space-y-1 text-gray-500 list-decimal list-inside dark:text-gray-400">
        <li>
          <span className="font-semibold text-gray-900 dark:text-white">
            {message[0]}
          </span>
        </li>
        <li>
          <span className="font-semibold text-gray-900 dark:text-white">
          {message[1]}
          </span>
        </li>
        <li>
          <span className="font-semibold text-gray-900 dark:text-white">
           {message[2]}
          </span>
        </li>
      </ol>
    </div>
  </div>
);

export default ConditionsDemande;
